module.exports = __webpack_public_path__ + "static/media/pic.1094a4e2.jpg";